/**
 * 에러 코드 정의
 * 클라이언트에서 에러 코드별로 사용자 친화적 메시지를 매핑하기 위해 사용
 */
export const ERROR_CODES = {
  // 공통 에러
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  VALIDATION_ERROR: "VALIDATION_ERROR",
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",

  // 초대 관련
  ALREADY_MEMBER: "ALREADY_MEMBER",
  ALREADY_INVITED: "ALREADY_INVITED",
  CANNOT_INVITE_SELF: "CANNOT_INVITE_SELF",
  INVITATION_NOT_FOUND: "INVITATION_NOT_FOUND",
  INVITATION_ALREADY_PROCESSED: "INVITATION_ALREADY_PROCESSED",
  NOT_YOUR_INVITATION: "NOT_YOUR_INVITATION",
  CANNOT_CANCEL_INVITATION: "CANNOT_CANCEL_INVITATION",

  // 워크스페이스 관련
  WORKSPACE_NOT_FOUND: "WORKSPACE_NOT_FOUND",
  MEMBER_NOT_FOUND: "MEMBER_NOT_FOUND",
  LAST_MASTER_CANNOT_LEAVE: "LAST_MASTER_CANNOT_LEAVE",
  CANNOT_EXPEL_SELF: "CANNOT_EXPEL_SELF",

  // 카테고리/수단 관련
  DUPLICATE_CATEGORY_NAME: "DUPLICATE_CATEGORY_NAME",
  CATEGORY_NOT_FOUND: "CATEGORY_NOT_FOUND",
  DUPLICATE_METHOD_NAME: "DUPLICATE_METHOD_NAME",
  METHOD_NOT_FOUND: "METHOD_NOT_FOUND",
  CANNOT_DELETE_DEFAULT_METHOD: "CANNOT_DELETE_DEFAULT_METHOD",

  // 정산 관련
  ADJUSTMENT_NOT_FOUND: "ADJUSTMENT_NOT_FOUND",
  ADJUSTMENT_ALREADY_COMPLETED: "ADJUSTMENT_ALREADY_COMPLETED",
  CANNOT_MODIFY_COMPLETED_ADJUSTMENT: "CANNOT_MODIFY_COMPLETED_ADJUSTMENT",
  INVALID_DATE_RANGE: "INVALID_DATE_RANGE",
  NOT_ADJUSTMENT_CREATOR: "NOT_ADJUSTMENT_CREATOR",

  // 지출 목표 관련
  SPENDING_GOAL_NOT_FOUND: "SPENDING_GOAL_NOT_FOUND",
  NOT_SPENDING_GOAL_CREATOR: "NOT_SPENDING_GOAL_CREATOR",
  NOT_SPENDING_GOAL_MEMBER: "NOT_SPENDING_GOAL_MEMBER",

  // 자산 관련
  ASSET_NOT_FOUND: "ASSET_NOT_FOUND",
  NOT_ASSET_OWNER: "NOT_ASSET_OWNER",

  // 로그 관련
  LOG_NOT_FOUND: "LOG_NOT_FOUND",
  NOT_LOG_CREATOR: "NOT_LOG_CREATOR",

  // 사용자 관련
  USER_NOT_FOUND: "USER_NOT_FOUND",
  DUPLICATE_DATA: "DUPLICATE_DATA",

  // 알림 관련
  NOTIFICATION_NOT_FOUND: "NOTIFICATION_NOT_FOUND",

  // 패치 파일럿 관련
  PATCH_PILOT_PROJECT_NOT_FOUND: "PATCH_PILOT_PROJECT_NOT_FOUND",
  PATCH_PILOT_TICKET_NOT_FOUND: "PATCH_PILOT_TICKET_NOT_FOUND",
  PATCH_PILOT_CATEGORY_NOT_FOUND: "PATCH_PILOT_CATEGORY_NOT_FOUND",
  PATCH_PILOT_INVALID_API_KEY: "PATCH_PILOT_INVALID_API_KEY",
  PATCH_PILOT_INVALID_STATUS_TRANSITION:
    "PATCH_PILOT_INVALID_STATUS_TRANSITION",
  PATCH_PILOT_RATE_LIMIT_EXCEEDED: "PATCH_PILOT_RATE_LIMIT_EXCEEDED",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

/**
 * API 에러 응답 인터페이스
 */
export interface ApiErrorResponse {
  error: string;
  code?: ErrorCode;
}
